import React from "react";

export default function TimelineTab({ activities }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6">
      {activities.length === 0 ? (
        <div className="text-sm text-slate-500 py-6 text-center">
          No activity yet.
        </div>
      ) : (
        <div className="timeline-line space-y-5">
          {activities.map((a) => (
            <div
              key={a.id}
              className="relative"
              data-testid={`timeline-event-${a.id}`}
            >
              <span className="timeline-dot" />
              <div className="text-sm text-slate-800">
                {a.details || a.action}
              </div>
              <div className="text-xs text-slate-500 mt-0.5">
                {new Date(a.timestamp).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
